import AccessRestricted from './AccessRestricted';

export default AccessRestricted;
